import template from './date-time-picker.html';
import controller from './date-time-picker.controller';


const DateTimePickerComponent = {
    template,
    controller,
    bindings: {
        model: '=ngModel',
        onChange: '&',
        maxDate: '<',
        minDate: '<',
        ngModel: '<',
        placeholder: '@',
        formControl: '@',
        same: '@',
        mode: '@',
        readOnly: '<'
    },
};

export default DateTimePickerComponent;



// WEBPACK FOOTER //
// ../widgets/date-time-picker/date-time-picker.component.js